import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';

const StyledIndicator = styled(CircularProgress)(({ theme }) => ({
  marginLeft: 3,
  color: theme.palette.text.secondary,
}));

const FolderLoadingIndicator = () => <StyledIndicator size={18} />;

export default FolderLoadingIndicator;
